(() => {
  angular.module('app').controller('host.views.employees', HostEmployeeController);

  HostEmployeeController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$interval',
    '$filter',
    '$q',
    'abp.services.app.hostEmployee',
    'Hms.Employees.EmployeeState',
    'Hms.Services.ServiceType',
    'Hms.PatientTickets.PatientTicketType',
    'Hms.Claims.ClaimType',
    'moment',
    'abp.services.app.tenant',
    'Hms.Finance.TransactionTenantType',
    'Hms.PatientSession.Status',
    'Hms.MultiTenancy.TenantClinicType',
    'Hms.GuaranteeLetters.GuaranteeLetterStatus',
    'Hms.ServiceRequests.ServiceRequestType',
    'Hms.ServiceRequests.ServiceRequestStatus',
    'Hms.Gender',
    'Hms.Policy.Status',
    'Hms.Policy.Type',
    'Hms.Policy.PaymentType',
  ];

  function HostEmployeeController(
    $scope,
    $state,
    $stateParams,
    $interval,
    $filter,
    $q,
    hostEmployeeSvc,
    enumEmployeeState,
    enumServiceType,
    enumPatientTicketType,
    enumClaimType,
    moment,
    tenantSvc,
    enumTransactionTenantType,
    enumPatientSessionStatus,
    enumTenantClinicType,
    enumGuaranteeLetterStatus,
    enumServiceRequestType,
    enumServiceRequestStatus,
    enumGender,
    enumPolicyStatus,
    enumPolicyType,
    enumPolicyPaymentType
  ) {
    const vm = this;

    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
    vm.defaultMaxAllowance = parseFloat(abp.setting.get('Hms.General.MaxAllowanceAmountLimit'));
    vm.loading = 0;
    vm.employees = null;
    vm.requestParams = {
      filter: $stateParams.filter,
      includeRelated: $stateParams.includeRelated,
      checkInDate: $stateParams.checkInDate,
    };

    vm.settings = {
      hasRegionalSystemSupport: abp.setting.getBoolean('Hms.Feature.RegionalSystemSupport'),

      // Check for inpatient module enable for the application.

      applicationHasInpatientModule: abp.setting.getBoolean('Hms.Feature.InpatientModule'),
      hasInpatientClaimProcessingEnhancement: abp.setting.getBoolean(
        'Hms.Feature.InpatientClaimProcessingEnhancement'
      ),

      hasHospitalizationWaitingPeriodEnhancement: abp.setting.getBoolean(
        'Hms.Feature.HospitalisationWaitingPeriodEnhancement'
      ),
      hasInsuranceEnhancementModule: abp.setting.getBoolean(
        'Hms.Feature.InsuranceEnhancementModule'
      ),
      hasPostHospitalizationGuaranteeLetterWorkflow: abp.setting.getBoolean(
        'Hms.Feature.PostHospitalizationGuaranteeLetterWorkflow'
      ),
    };
    vm.canApplyPostHospitalizationGL = false;

    vm.enums = {
      employeeState: enumEmployeeState,
      serviceType: enumServiceType,
      patientTicketType: enumPatientTicketType,
      claimType: enumClaimType,
      transactionTenantType: enumTransactionTenantType,
      patientSessionStatus: enumPatientSessionStatus,
      tenantClinicType: enumTenantClinicType,
      glStatus: enumGuaranteeLetterStatus,
      requestType: enumServiceRequestType,
      requestStatus: enumServiceRequestStatus,
      gender: enumGender,
      policyStatus: enumPolicyStatus,
      policyType: enumPolicyType,
      policyPaymentType: enumPolicyPaymentType,
    };

    vm.benefitTypeCodes = {};

    const hasManageInpatient = abp.auth.isGranted('Host.Claims.Inpatient.Manage');
    vm.permissions = {
      canViewTickets: abp.auth.isGranted('PatientTickets'),
      canReimburse: abp.auth.isGranted('PatientTickets.Reimbursement.Create') || hasManageInpatient,
      canCreateManualTicket:
        abp.auth.isGranted('PatientTickets.Host.Manual.Create') || hasManageInpatient,
      canViewClaims: abp.auth.isGranted('Host.Claims'),
      canCreateGuaranteeLetter: abp.auth.isGranted('GuaranteeLetters.Host.Create'),
      createManualTransaction: abp.auth.isGranted(
        'HealthMetrics.Finance.ManualTransactionRequests.Create'
      ),
      canManageInsuranceEnrolmentFlag: abp.auth.isGranted(
        'Host.ManageMemberInsuranceEnrolmentFlag'
      ),
    };
    vm.hasHubIntegrationFeatureEnabled = abp.setting.getBoolean('Hms.Feature.HubIntegration');

    vm.tickerProgressBarValue = 100;
    vm.getEmployees = getEmployees;

    vm.hubEmployees = [];

    // Bumped by every search, so only the latest search's results are shown.
    let latestSearchId = 0;

    init();

    function init() {
      if (vm.requestParams.filter) vm.getEmployees();

      let tickerInterval = $interval(tickerJob, 1000);
      $scope.$on('$destroy', () => {
        if (angular.isDefined(tickerInterval)) {
          $interval.cancel(tickerInterval);
          tickerInterval = undefined;
        }
      });
    }

    function registerStateParams() {
      const processed = {};
      if (vm.requestParams.checkInDate)
        processed.checkInDate = moment(vm.requestParams.checkInDate).format('YYYY-MM-DD');

      $state.transitionTo($state.current, $.extend({}, vm.requestParams, processed), {
        notify: false,
      });
    }

    function getCorporateActiveServices() {
      const corporateIds = [];

      // Get distinct corporate ids.

      _.each(vm.employees, (employee) => {
        if (corporateIds.indexOf(employee.corporateId) < 0) {
          corporateIds.push(employee.corporateId);
        }
      });

      // Get corporate active services, assign to employees according to corporateId.

      _.each(corporateIds, (id) => {
        vm.loading += 1;
        tenantSvc
          .getTenantActiveServices({ id })
          .success((data) => {
            const corporateEmployees = vm.employees.filter((e) => e.corporateId === id);

            _.each(corporateEmployees, (employee) => {
              _.assign(employee, {
                activeServices: data,
              });
            });
          })
          .finally(() => {
            vm.loading -= 1;
          });
      });
    }

    // A failed search counts as finding nobody, so the other search's cards can still show.
    // The usual error dialog still reports a request the portal itself failed.
    function searchEmployees() {
      return hostEmployeeSvc
        .getEmployees(vm.requestParams)
        .then((response) => response.data.items || [])
        .catch(() => []);
    }

    function searchHubEmployees() {
      if (!vm.hasHubIntegrationFeatureEnabled) return $q.resolve([]);

      return hostEmployeeSvc
        .getHostHubEmployees(vm.requestParams)
        .then((response) => response.data.items || [])
        .catch(() => []);
    }

    function getEmployees() {
      latestSearchId += 1;
      const searchId = latestSearchId;

      registerStateParams();

      // Start every search from an empty page so nothing from an earlier search survives.
      vm.employees = [];
      vm.hubEmployees = [];
      vm.canApplyPostHospitalizationGL = false;
      vm.benefitTypeCodes = {};

      vm.loading += 1;
      $q.all([searchEmployees(), searchHubEmployees()])
        .then(([employees, hubEmployees]) => {
          // A newer search has started, for example by ticking Include related people.
          if (searchId !== latestSearchId) return;

          // Decide once both searches settle: a Hub match shows only the Hub cards.
          if (hubEmployees.length > 0) {
            vm.hubEmployees = hubEmployees;
            return;
          }

          vm.employees = employees;
          _.each(vm.employees, (employee) => {
            const ticketServiceTypes = [];
            const isMasterPolicyExpired =
              employee.masterPolicy &&
              moment().startOf('day').utc() > moment(employee.masterPolicy.endDate).utc();

            _.each(employee.serviceTypes, (service) => {
              if (!service.isCustom) {
                service.name = App.localize(service.name);
              }

              service.benefits = [];
              if (service.coPay) {
                if (service.coPay.isPercentage) {
                  service.coPay.title = App.localize('CopayX', `${service.coPay.value}%`);
                  service.coPay.text = App.localize('CopayPercentage', `${service.coPay.value}%`);
                } else {
                  const valueText = $filter('currencyFormat')(service.coPay.value, vm.currencyCode);
                  service.coPay.title = App.localize('CopayX', valueText);
                  service.coPay.text = App.localize('CopayFixedAmount', valueText);
                }
              }
              if (service.balancePools && service.balancePools.length) {
                _.each(service.balancePools, (d) => {
                  let title = _.join(
                    _.map(d.benefitTypes, (bt) => {
                      if (bt.isCustom) {
                        let strCt = `CT${bt.id}`;
                        const idx = _.findIndex(
                          employee.customizedTreatments,
                          (ctn) => ctn.value === bt.id
                        );
                        if (idx !== -1) strCt = employee.customizedTreatments[idx].name;
                        return strCt;
                      }
                      if (bt.id === 251) {
                        return App.localize('Hospitalization');
                      }

                      return App.localize(bt.name);
                    }),
                    '/'
                  );

                  // TODO: Better design? localisation required

                  const isBudget = d.modifierType === 0 || d.modifierType === 2;
                  let cycle = '';
                  if (!d.isUnlimited) {
                    // eslint-disable-next-line default-case
                    switch (d.modifierCycle) {
                      case 0:
                        cycle = `every ${d.interval} years `;
                        break;
                      case 1:
                        cycle = 'annual ';
                        break;
                      case 2:
                        cycle = 'monthly ';
                        break;
                      case 3:
                        cycle = 'daily ';
                        break;
                      case 4:
                        cycle = 'per visit ';
                        break;
                      case 5:
                        cycle = '6 months ';
                        break;
                      case 6:
                        cycle = '4 months ';
                        break;
                      case 7:
                        cycle = '3 months ';
                        break;
                      case 8:
                        cycle = '2 months ';
                        break;
                      case 9:
                        cycle = `every ${d.interval} months `;
                        break;
                    }
                    if (d.modifierType === 2 || d.modifierType === 3) cycle += 'overdraft ';
                  }
                  title += ` (${cycle}${isBudget ? 'budget' : 'visit'})`;

                  const isEmptyExcess = d.isExcess && !d.employeePortion;
                  if (!isEmptyExcess) {
                    service.benefits.push({
                      title,
                      isUnlimited: d.isUnlimited,
                      isExcess: d.isExcess,
                      isBudget,
                      limit: d.limit,
                      used: d.used,
                      locked: d.locked,
                      balance: d.balance,
                    });
                  }

                  // Retrieve the benefit types for display purposes.

                  d.benefitTypes.forEach((x) => {
                    vm.benefitTypeCodes[x.displayName] = x.code;
                  });
                });
              }
              service.allowance = Math.min(service.allowance, vm.defaultMaxAllowance);

              if (service.serviceType === 5) {
                _.assign(employee, {
                  hasSpecialist: true,
                });
              }

              if (service.serviceType !== 4) {
                ticketServiceTypes.push({
                  canCreate: true,
                  name: service.name,
                  serviceType: service.serviceType,
                });
              }

              if (
                (service.serviceType === 7 && !isMasterPolicyExpired) ||
                service.serviceType === 8
              ) {
                _.assign(employee, {
                  hasInpatientBenefit: true,
                });
              }
            });

            // HM-9745: Get all the utilizations of the employee to display in sob.

            const employeeUtilizations = {};

            _.each(employee.serviceTypes, (serviceType) => {
              const { name } = serviceType;

              const budgetBenefit = serviceType.benefits.find((benefit) => benefit.isBudget);
              if (!budgetBenefit) return;

              employeeUtilizations[name] = {
                utilizationAmount: budgetBenefit.used,
                utilizationLimit: budgetBenefit.limit,
              };
            });

            if (employee.inpatientBenefits && employee.inpatientBenefits.length > 0) {
              _.assign(employee, {
                inpatientTypes: _.filter(employee.serviceTypes, (item) => item.isHospitalize),
              });

              _.each(employee.inpatientTypes, (p) => {
                const inpatientInfo = _.find(employee.inpatientBenefits, [
                  'serviceType',
                  p.serviceType,
                ]);
                const hospitalizationLimitUsages = {};
                _.each(p.balancePools, (q, index) => {
                  const limits = {
                    Hospitalization: q.employeePortionByBenefitType?.Hospitalization,
                    PostHospitalization: q.employeePortionByBenefitType?.PostHospitalization,
                  };

                  if (limits.Hospitalization != null || limits.PostHospitalization != null) {
                    const benefit = p.benefits[index];

                    if (benefit) {
                      if (benefit.isBudget) {
                        hospitalizationLimitUsages.BudgetLimit = limits;
                      } else {
                        hospitalizationLimitUsages.VisitLimit = limits;
                      }
                    }
                  }
                });

                if (Object.keys(hospitalizationLimitUsages).length > 0) {
                  p.hospitalizationLimitUsages = hospitalizationLimitUsages;
                }

                vm.canApplyPostHospitalizationGL =
                  vm.settings.hasPostHospitalizationGuaranteeLetterWorkflow;

                if (inpatientInfo) {
                  p.supportPlanName = inpatientInfo.name;
                  p.supportPlanDisplayName = inpatientInfo.displayName;
                  p.supportPlanRemarks = inpatientInfo.remarks;

                  p.employeeUtilizations = employeeUtilizations;

                  if (p.serviceType === 7) {
                    p.name = App.localize('Hospitalization');
                    if (employee.masterPolicy) {
                      p.name = App.localize('Insurance');
                      employee.masterPolicy.startDate = moment(
                        employee.masterPolicy.startDate
                      ).format('DD/MM/YYYY');
                      p.supportPlanName = `${p.supportPlanName} (${employee.masterPolicy.masterPolicyNumber})`;
                    }
                    employee.customizedTreatments.unshift({
                      canCreate: true,
                      name: App.localize('HospitalizationTicket'),
                      value: 7,
                    });

                    p.settings = inpatientInfo.hospitalizationSetting;
                    if (inpatientInfo.hospitalizationSetting.coPays != null) {
                      // eslint-disable-next-line prefer-destructuring
                      p.coPay = inpatientInfo.hospitalizationSetting.coPays[0];
                    }
                  } else if (p.serviceType === 8) {
                    p.name = App.localize('Maternity');
                    employee.customizedTreatments.unshift({
                      canCreate: true,
                      name: App.localize('MaternityTicket'),
                      value: 8,
                    });

                    p.settings = inpatientInfo.maternitySetting;
                    if (inpatientInfo.maternitySetting.coPays != null) {
                      // eslint-disable-next-line prefer-destructuring
                      p.coPay = inpatientInfo.maternitySetting.coPays[0];
                    }
                  }
                } else {
                  p.supportPlanName = employee.supportPlanName;
                  p.supportPlanDisplayName = employee.supportPlanDisplayName;
                  p.supportPlanRemarks = employee.supportPlanRemarks;
                }

                p.allowance = Math.min(p.allowance, vm.defaultMaxAllowance);

                if (p.coPay) {
                  if (p.coPay.isPercentage) {
                    p.coPay.title = App.localize('CopayX', `${p.coPay.value}%`);
                    p.coPay.text = App.localize('CopayPercentage', `${p.coPay.value}%`);
                  } else {
                    const valueText = $filter('currencyFormat')(p.coPay.value, vm.currencyCode);
                    p.coPay.title = App.localize('CopayX', valueText);
                    p.coPay.text = App.localize('CopayFixedAmount', valueText);
                  }
                }
              });

              employee.serviceTypes = _.filter(
                employee.serviceTypes,
                (item) => !item.isHospitalize
              );
            }

            employee.ticketServiceTypes = ticketServiceTypes;

            // Default the number of check-ins to be display to 1.
            employee.checkInsDisplayLimit = 1;

            // Default to non-hospitalization tab (0).
            employee.benefitsActiveTab = 0;
          });

          getCorporateActiveServices();
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function tickerJob() {
      if (!vm.employees || !Array.isArray(vm.employees)) return;

      vm.employees.forEach((employee) => {
        if (!employee.recentActivities || !Array.isArray(employee.recentActivities)) return;

        employee.recentActivities.forEach((activity) => {
          // Only process activities with Active status.
          if (activity.status !== vm.enums.patientSessionStatus.Active.id) return;

          const expiryMoment = moment(activity.expiryTime, 'DD/MM/YYYY h:mma Z');
          if (!expiryMoment.isValid()) return;

          const totalSeconds = expiryMoment.diff(moment(), 'seconds');
          const duration = moment.duration(totalSeconds, 'seconds');

          if (totalSeconds <= 0) {
            activity.remainingTime = null;
            activity.status = vm.enums.patientSessionStatus.Expired.id;
          } else {
            const days = duration.days();
            const hours = duration.hours();
            const minutes = duration.minutes();
            const seconds = duration.seconds();

            let str = '';
            if (days > 0) str += `${days}d `;
            if (hours > 0) str += `${_.padStart(hours, 2, '0')}h `;
            str += `${_.padStart(minutes, 2, '0')}m ${_.padStart(seconds, 2, '0')}s`;

            activity.remainingTime = str;
          }

          let limit = 24 * 60 * 60;
          if (activity.isPreEmployee) {
            limit *= 7;
          }

          activity.progressPercentage = Math.max(0, Math.min(100, (totalSeconds / limit) * 100));
        });
      });
    }
  }
})();
